import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
    constructor(private readonly snackBar: MatSnackBar) {}

    public success(message: string): void {
        this.snackBar.open(message, 'Fermer', {
            panelClass: 'custom-snackbar-success',
            verticalPosition: 'bottom',
            horizontalPosition: 'right'
        });
    }

    public error(message: string): void {
        this.snackBar.open(message, 'Fermer', {
            panelClass: 'custom-snackbar-error',
            verticalPosition: 'bottom',
            horizontalPosition: 'right'
        });
    }

    public warning(message: string): void {
        this.snackBar.open(message, 'Fermer', {
            panelClass: 'custom-snackbar-warning',
            verticalPosition: 'bottom',
            horizontalPosition: 'right'
        });
    }
}